<template>
  <ItemDialog ref="dialogRef" imageType="done">
    <template v-slot:content-area>
      <h2>予約完了</h2>
      <p style="text-align: center">予約が完了しました</p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="閉じる"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogReservationSuccessful",
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
      nativeHandlerService.returnNativeDbsIndexPage();
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>
